<template>
  <footer class="footer pt-0 px-4 mx-2">
    <div class="row align-items-end justify-content-lg-end">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-right text-muted">
          © {{ year }}
          <a
            href="https://reddonedigital.com"
            class="font-weight-bold ml-1"
            target="_blank"
            >Redd One Digital</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
